import { Popover, Select } from 'antd'
import WizrButton from '../WizrButton'
import WizrFlexLayout from '../WizrFlexLayout'
import CreateNew from '../../assets/icons/CreateNew'
import styled from 'styled-components'
import { useState } from 'react'

interface FilterPopoverProps {
  columnOptions: any[]
  selectedFilters: string[]
  onFiltersChange: (filters: string[]) => void
}

const FilterContent = ({ columnOptions, selectedFilters, onFiltersChange }: FilterPopoverProps): JSX.Element => {
  const [dropValue, setDropValue] = useState(selectedFilters)

  const handleChange = (value: any) => {
    console.log('selected filters:', value)
    setDropValue(value)
    onFiltersChange(value)
  }
  
  return (
    <WizrFlexLayout textAlign='left' background='#FFF' style={{minWidth: '312px'}}>
      <StyledWizrTagInput
        mode='multiple'
        options={columnOptions}
        value={dropValue}
        onChange={handleChange}
        maxTagCount={'responsive'}
        placeholder="Select filter columns"
      />
    </WizrFlexLayout>
  )
}

const FilterPopover = ({ columnOptions, selectedFilters, onFiltersChange }: FilterPopoverProps) => {
  return (
    <Popover 
      content={
        <FilterContent 
          columnOptions={columnOptions}
          selectedFilters={selectedFilters}
          onFiltersChange={onFiltersChange}
        />
      } 
      title='' 
      trigger='click' 
      style={{width: '312px'}}
    >
      <StyledPlusButton
        type='primary'
        icon={<CreateNew fill='white' />}
      />
    </Popover>
  )
}

export default FilterPopover

const StyledPlusButton = styled(WizrButton)`
  background-color: black;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
`

const StyledWizrTagInput = styled(Select)`
  /* Add your custom styles here */
  .ant-select-selection-placeholder {
    text-align: left;
  }
  width: 100%;
  .ant-select-selector {
    min-height: 50px;
    background: #f2f4f9 !important;
    border-radius: 16px !important;
    padding-left: 20px !important;
  }
  .ant-select-selection-item {
    background: white !important;
    border-radius: 20px !important;
    border: 1px solid black !important;
    gap: 8px !important;
    padding-right: 8px !important;
  }
  .ant-select-selection-overflow {
    gap: 8px !important;
  }
  overflow: auto; /* Hide any overflow content */
`